import { type ListingProduct, ListingProductCode } from 'src/generated/graphql';

import type { DesktopFeaturesFreemium } from './desktop';
import type { MobileFeaturesFreemium } from './mobile';

export type ListingPackageInfoFreemium = {
  productCode: ListingProduct['productCode'];
  description: string;
  features: {
    desktop: DesktopFeaturesFreemium;
    mobile: MobileFeaturesFreemium;
  };
};

export const listingProductsFreemium: ListingPackageInfoFreemium[] = [
  {
    productCode: ListingProductCode.Freemium,
    description: 'Starting your selling journey',
    features: {
      desktop: {
        duration: '6month',
        listing: 'enabled',
        connections: 'enabled',
        photo: 'disabled',
        searchRank: 'disabled',
        boostedEmail: 'disabled',
        featuredSearch: 'disabled',
        featuredEmail: 'disabled',
      },
      mobile: {
        duration: { enabled: true, label: '6 months' },
        listing: { enabled: true },
        connections: { enabled: true },
        photo: { enabled: true },
        searchRank: { enabled: true },
        boostedEmail: { enabled: true },
        featuredSearch: { enabled: true },
        featuredEmail: { enabled: true },
      },
    },
  },
  {
    productCode: ListingProductCode.ListUntilSold,
    description: 'Get noticed by more buyers',
    features: {
      desktop: {
        duration: 'lus',
        listing: 'enabled',
        connections: 'enabled',
        photo: 'enabled',
        searchRank: 'enabled',
        boostedEmail: 'disabled',
        featuredSearch: 'disabled',
        featuredEmail: 'disabled',
      },
      mobile: {
        duration: { enabled: true },
        listing: { enabled: true },
        connections: { enabled: true },
        photo: { enabled: true },
        searchRank: { enabled: true },
        boostedEmail: { enabled: true },
        featuredSearch: { enabled: true },
        featuredEmail: { enabled: true },
      },
    },
  },
  {
    productCode: ListingProductCode.Accelerate,
    description: 'Reach the right buyers faster',
    features: {
      desktop: {
        duration: 'lus',
        listing: 'enabled',
        connections: 'enabled',
        photo: 'enabled',
        searchRank: 'enabled',
        boostedEmail: 'enabled',
        featuredSearch: 'enabled',
        featuredEmail: 'enabled',
      },
      mobile: {
        duration: { enabled: true },
        listing: { enabled: true },
        connections: { enabled: true },
        photo: { enabled: true },
        searchRank: { enabled: true },
        boostedEmail: { enabled: true },
        featuredSearch: { enabled: true },
        featuredEmail: { enabled: true },
      },
    },
  },
] satisfies ListingPackageInfoFreemium[];
